import script from "./AddPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPhoneNumberModal.vue?vue&type=style&index=0&id=195aa417&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195aa417"]])

export default __exports__